<template>
  <div>
    <Breadcrumbs
      main-link="welcome"
      :main="$t('dashboardVue.dashboard')"
      :title="`Yeni hərrac`"
    />
    <!-- Container-fluid starts-->
    <div class="container">
      <h4 class="mb-3">
        {{ $t('newAUCRequest.yeniHrrac') }}
      </h4>

      <input
        id="fileInput"
        ref="file"
        type="file"
        style="display: none"
        @change="setPhoto"
      >

      <div class="card bg-light">
        <div class="card-body text-dark d-flex ">
          <div class="mr-3">
            <feather type="info" />
          </div>
          <div>
            {{ $t('newAUCRequest.hrracnYalnzBirQalibiOlaBilr') }} <br>
            {{ $t('newAUCRequest.qalibIrktinTklifiniSasszYerImtinaEdrsizsQarTrfSizi') }}
            <br>
            {{ $t('newAUCRequest.saslandrmanzYalnzMzakirlrdEtdiyinizDanaGrMyynOluna') }} <br>
            {{ $t('newAUCRequest.btnDetallarMzakirBlmsindAparmanzTlbOlunur') }}
          </div>
        </div>
      </div>


      <form @submit.prevent="createRequest">
        <div class="card shadow">
          <div class="card-body">
            <h4>
              {{ $t('newAUCRequest.hrracnzHansSahyAiddir') }}
            </h4>

            <p>
              {{ $t('newAUCRequest.sorununYaradarknFaliyytSahsiniSemkMtlqdirSizMaximu') }}
            </p>

            <div class="mt-3">
              <button
                v-b-modal.modal-sector-selection
                type="button"
                class="btn btn-sm btn-light-primary"
              >
                {{ $t('companyProfile.faliyytSahsiniSein') }}
              </button>
            </div>

            <hr v-if="requestSectors.length>0">
            <SelectedSectorView
              :sectors="requestSectors"
              :parent-id="0"
            />
          </div>
        </div>


        <div class="card">
          <div class="card-body">
            <h4>{{ $t('newAUCRequest.soruDetallar') }}</h4>
            <hr>


            <div class="mb-3">
              <label> {{ $t('newAUCRequest.hrracnAd') }}</label>
              <b-form-input
                id="new_request_title"
                v-model="requestTitle"
                type="text"
                required
              />
            </div>


            <div v-if="requestType === 'AUC'">
              <div class="mb-3 w-50">
                <label>{{ $t('newAUCRequest.balancQiymt') }}</label>
                <div class="input-group">
                  <b-form-input
                    v-model="orderExtras.startingPrice"
                    type="number"
                    min="1"
                    required
                  />
                  <div class="input-group-append">
                    <div class="input-group-text">
                      {{ $t('newAUCRequest.azn') }}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="mb-3">
              <label>{{ $t('newAUCRequest.hrracBardMlumatlar') }}</label>
              <b-form-textarea
                id="new_request_description"
                v-model="requestDescription"
                required
                rows="4"
              />
              <span
                v-if="requestDescription.length<20"
                class="text-secondary"
              >{{ $t('newAUCRequest.soruSpesifikasiyasNAz20SimvoldanIbartOlmaldr') }}</span>
            </div>


            <div class="mb-3 w-50">
              <label>
                {{ $t('newAUCRequest.hrracNSonTarix') }}
              </label>
              <DatePicker
                v-model="requestDeadline"
                mode="dateTime"
                is24hr
                :locale="$i18n.locale==='az'?undefined: $i18n.locale"
                :minute-increment="15"
                :min-date="minDeadline"
                :is-required="true"
                :model-config="{type: 'string', mask: 'YYYY-MM-DD HH:mm:ss'}"
              >
                <template #default="{ inputValue, inputEvents }">
                  <input
                    type="text"
                    class="form-control "
                    :value="inputValue"
                    placeholder=""
                    required
                    v-on="inputEvents"
                  >
                </template>
              </DatePicker>
            </div>


            <div class=" d-flex align-items-center">
              <div class="checkbox checkbox-primary">
                <b-form-checkbox
                  v-model="requestIsPrivate"
                  value="1"
                  :disabled="onlyVendors>0"
                >
                  <div>
                    {{ $t('newAUCRequest.mllifiGizlt') }} <br>
                    <span
                      v-if="requestIsPrivate"
                      class="text-danger"
                    > {{ $t('newAUCRequest.mllifiDigrIstifadilrYalnzMzakiryBalayarsaGrcklr') }}</span>
                    <span
                      v-else
                      class="text-success"
                    >{{ $t('newAUCRequest.mllifiBtnIstifadilrGrcklr') }}  </span>
                  </div>
                </b-form-checkbox>
              </div>
            </div>

            <div class=" d-flex align-items-center">
              <div class="checkbox checkbox-primary">
                <b-form-checkbox
                  v-model="requestIsPersonalAllowed"
                  value="1"
                >
                  {{ $t('newAUCRequest.frdiVensizXslrSorunuCavablayaBilsin') }}
                </b-form-checkbox>
              </div>
            </div>
          </div>
        </div>


        <div class="card shadow">
          <div class="card-body">
            <div class="d-flex justify-content-between align-items-center">
              <h4> {{ $t('newAUCRequest.mhsullar') }} </h4>

              <button
                type="button"
                class="btn btn-sm btn-light-primary"
                @click.prevent="addNewProduct()"
              >
                {{ $t('newAUCRequest.yeniMhsulLavEt') }}
              </button>
            </div>

            <hr>

            <table class="table table-bordernone product-table">
              <thead>
                <tr>
                  <th>{{ $t('newAUCRequest.tip') }}</th>
                  <th>{{ $t('newAUCRequest.mhsulunxidmtinAd') }}</th>
                  <th>{{ $t('newAUCRequest.miqdar') }}</th>
                  <th>{{ $t('newAUCRequest.mhsulxidmtHaqqndaQeydlr') }}</th>
                  <th>{{ $t('newAUCRequest.lavFayl') }}</th>
                  <th />
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(p,i) in products"
                  :key="i"
                >
                  <td>
                    <span v-if="p.productType==='PRODUCT'">{{ $t('newAUCRequest.mhsul') }}</span>
                    <span v-else-if="p.productType==='SERVICE'">{{ $t('newAUCRequest.xidmt') }}</span>
                    <span v-else>{{ p.productType }}</span>
                  </td>
                  <td class="can-wrap">
                    {{ p.name }}
                  </td>
                  <td>{{ p.count }} {{ p.unit }}</td>
                  <td class="can-wrap">
                    {{ p.note }}
                  </td>
                  <td>
                    <span v-if="p.photo">
                      *.{{ p.photo.split('.').pop() }}
                    </span>
                    <span v-else>-</span>
                  </td>
                  <td class="text-right">
                    <button
                      type="button"
                      class="btn btn-sm p-2 btn-light-success"
                      @click="editProduct(i)"
                    >
                      <feather
                        type="edit-3"
                        size="12"
                      />
                      {{ $t('newAUCRequest.dzliEt') }}
                    </button>
                    <button
                      type="button"
                      class="btn btn-sm p-2 btn-light-danger ml-2"
                      @click="deleteProduct(i)"
                    >
                      <feather
                        type="x"
                        size="12"
                      />
                    </button>
                  </td>
                </tr>
                <tr
                  v-if="products.length<1"
                  class="not-found"
                >
                  <td colspan="6">
                    <div class="alert alert-warning">
                      {{ $t('newAUCRequest.mhsulLavEdilmyib') }}
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <button class="btn btn-primary">
          <span>{{ $t('newAUCRequest.hrracYarat') }}</span>
        </button>
      </form>
    </div>
    <!-- Container-fluid Ends-->

    <b-modal
      id="modal-sector-selection"
      centered
      :title="$t('companyProfile.faliyytSahsiniSein')"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      :hide-header-close="false"
      class="theme-modal"
      :busy="false"
      :hide-footer="true"
    >
      <sector_selection_modal
        :max-selection="5"
        :parent-sector="null"
        :selected="requestSectors"
        @done="sectorSelected($event)"
      />
    </b-modal>

    <b-modal
      id="modal-edit-product"
      size="lg"
      centered
      :title="$t('newAUCRequest.mhsul')"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      :hide-header-close="true"
      class="theme-modal"
      :hide-footer="true"
    >
      <form @submit.prevent="saveProduct">
        <div
          v-if="editingProductIndex>-1"
          class="card-body"
        >
          <div class="row">
            <div class="col-md-6">
              <div class="mb-3">
                <label>{{ $t('newAUCRequest.tip') }}</label>
                <select
                  v-model="editingProduct.productType"
                  class="form-control"
                  required
                >
                  <option value="PRODUCT">
                    {{ $t('newAUCRequest.mhsul') }}
                  </option>
                  <option value="SERVICE">
                    {{ $t('newAUCRequest.xidmt') }}
                  </option>
                </select>
              </div>

              <div class="mb-3">
                <label>{{ $t('newAUCRequest.mhsulunXidmtinAd') }}</label>
                <input
                  v-model="editingProduct.name"
                  class="form-control"
                  type="text"
                  required
                >
              </div>

              <div class="mb-3">
                <label>{{ $t('newAUCRequest.mhsulXidmtHaqqndaQeydlr') }}</label>
                <textarea
                  v-model="editingProduct.note"
                  class="form-control"
                  type="text"
                />
              </div>


              <div class="mb-3">
                <div class="row">
                  <div class="col-6">
                    <label>{{ $t('newAUCRequest.miqdar') }}</label>
                    <input
                      v-model="editingProduct.count"
                      class="form-control"
                      type="number"
                      step="any"
                      required
                    >
                  </div>
                  <div class="col-6">
                    <label>{{ $t('newAUCRequest.lVahidi') }}</label>
                    <select
                      v-if="editingProduct.productType==='SERVICE'"
                      v-model="editingProduct.unit"
                      class="form-control"
                      required
                    >
                      <option
                        v-for="v in serviceUnits"
                        :key="v"
                        :value="v"
                      >
                        {{ v }}
                      </option>
                    </select>
                    <select
                      v-else
                      v-model="editingProduct.unit"
                      class="form-control"
                      required
                    >
                      <option
                        v-for="v in productUnits"
                        :key="v"
                        :value="v"
                      >
                        {{ v }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-6">
              <label>{{ $t('newAUCRequest.lavFayl') }}</label> <br>
              <div v-if="editingProduct.photo">
                <img
                  v-if="isPhoto(editingProduct.photo)"
                  :src="getPhoto(editingProduct.photo,'mediumCropped')"
                  alt=""
                  class="img-thumbnail"
                  style="max-height: 300px; max-width: 100%;"
                >
                <div
                  v-else
                  class="p-3 border border-secondary rounded"
                >
                  *.{{ editingProduct.photo.split('.').pop()}} {{ $t('newAUCRequest.editingproductphotosplitpopFayl') }}
                </div>
              </div>
              <div class="mt-2 ">
                <button
                  type="button"
                  class="btn btn-sm mr-2 btn-light-primary"
                  @click.prevent="selectPhoto(1)"
                >
                  {{ $t('newAUCRequest.ykl') }}
                </button>
                <button
                  v-if="editingProduct.photo"
                  type="button"
                  class="btn btn-sm  mr-2 btn-light-danger"
                  @click.prevent="editingProduct.photo=''"
                >
                  <i class="fa fa-trash" />
                </button>
              </div>
            </div>

            <div class="col-12 d-flex justify-content-between">
              <button
                type="submit"
                class="btn btn-primary mr-3"
              >
                {{ $t('sectorSelectionModal.yaddaSaxla') }}
              </button>
              <button
                type="button"
                class="btn btn-light-danger"
                @click.prevent="cancelSaveProduct"
              >
                {{ $t('companyProfile.lvEt') }}
              </button>
            </div>
          </div>
        </div>
      </form>
    </b-modal>
  </div>
</template>
<script>
import {mapState} from "vuex";
import {
  createRequest, createRequestFromExcel, getVendorManagementStatus,
  getWorkingSectors, upload
} from "@/repositories/GeneralDataRepository";
import {mediaBase} from "@/repositories/Repository";

import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import Datepicker from 'vuejs-datepicker';
import {deliveryTypes, getPhoto, loadTypes} from "@/repositories/Utils";
import Sector_selection_modal from "@/components/sector_selection_modal.vue";
import Sector_path from "@/components/sector_path.vue";
import SelectedSectorView from "@/components/SelectedSectorsView.vue";
import dayjs from "dayjs";

export default {
  components: {
    SelectedSectorView,
    Sector_path,
    Sector_selection_modal,
    Multiselect, Datepicker
  },
  data() {
    return {
      mediaBase: mediaBase,
      requestType: 'AUC',
      requestSubType: '',
      faq: [],
      requestTitle: '',
      requestDescription: '',
      requestIsPrivate: 0,
      requestIsPersonalAllowed: 0,
      onlyVerified: 0,
      onlyVendors: 0,
      requestDeadline: '',
      requestFiles: [],
      requestSectors: [],
      sectors: [],
      uploadProgress: 0,
      products: [],
      editingProduct: null,
      editingProductIndex: -1,

      photoIndex: 0,
      rfqTerms: 0,
      orderExtras: {
        pickUpCountry: '',
        pickUpCity: '',
        pickUpAddress: '',
        dropOffCountry: '',
        dropOffCity: '',
        dropOffAddress: '',
        deadline: '',
        notes: '',
        incoterms: '',
        types: [],
        loadSize: '',
        loadUnit: '',
        multiSelect: 0,
        ownVariant: 0
      },
      //TODO LANGUAGE
      format: "dd MMM yyyy",
      inctermsList: ["EXW", "FOB", "CIF", "FCA", "DPU", "CFR", "CIP", "DAP", "DDP"],
      typeList: deliveryTypes(),
      advTypeList: loadTypes(),
      productUnits: this.$t("productUnits"),
      serviceUnits: this.$t("serviceUnits"),
      loadUnits: this.$t("loadUnits"),
      pollAnswerList: [],

      vendorManagementAvailable: false
    };
  },
  watch: {

    "$route"() {
      this.requestType = this.$route.query.type;
    },
    onlyVerified(newVal) {
      if (newVal) {
        this.$swal({
          //TODO LANGUAGE
          title: this.$t("generalModal.warningTitle"),
          text: this.$t("newAUCRequest.onlyVerifiedModalText"),
          icon: 'warning'
        })
      }
    },
    onlyVendors(newVal) {
      if (newVal) {
        // this.$swal({
        //   //TODO LANGUAGE
        //   title: this.$t("generalModal.warningTitle"),
        //   text: this.$t("newAUCRequest.onlyVendorModalText"),
        //   icon: 'warning'
        // })
      }
    },
  },
  computed: {
    ...mapState({
      token: state => state.auth.token,
      user: state => state.auth.user,
      profile: state => state.auth.profile,
    }),

    minDeadline() {
      return dayjs().add(1, "day").format("YYYY-MM-D");
    }

  },
  mounted() {

    getVendorManagementStatus(this.token).then(({code}) => {
      this.vendorManagementAvailable = (code === 200);
    })

  },
  methods: {
    isPhoto(path) {
      return ['jpg', 'png', 'gif', 'jpeg'].indexOf(path.toLowerCase().split('.').pop()) > -1;
    },

    sectorSelected(sectors) {
      this.requestSectors = sectors;
      this.$bvModal.hide('modal-sector-selection');
    },
    createRequest() {
      let sectors = this.requestSectors.map(function (elem) {
        return elem.id;
      }).join(",");

      let extras =    {
          "version": "1.0.0",
          "startingPrice": this.orderExtras.startingPrice
        };


         this.requestSubType = this.requestType;

      if (this.requestTitle !== '' &&   this.requestDescription.length >= 20 && (sectors + "").length > 0) {

        createRequest(
            this.token,
            this.requestType, this.requestSubType,
            sectors,
            this.requestTitle, this.requestFiles, this.requestDescription,
            this.requestDeadline,
            this.requestIsPrivate, this.requestIsPersonalAllowed,
            this.onlyVerified, this.onlyVendors,
            JSON.stringify(extras),
            this.products, this.pollAnswerList
        ).then(data => {

          if (data.code === 200) {

            this.$router.replace('/dashboard/request/' + data.id);

          } else {
            this.$swal({
              title: `Error ${data.code}`,
              text: `${data.message}`,
              icon: 'error'
            })
          }

        })

      } else if (sectors.length < 1) {
        this.$swal({
          //TODO LANGUAGE

          title: this.$t("generalModal.warningTitle"),
          text: this.$t("generalModal.noWorkingSectorWarning"),
          icon: 'error'
        })
      } else if (['LOG', 'TRS', 'TRK'].indexOf(this.requestType) === -1 && this.requestDescription.length < 20) {
        this.$swal({
          //TODO LANGUAGE

          title: this.$t("generalModal.warningTitle"),
          text: this.$t("newAUCRequest.soruSpesifikasiyasNAz20SimvoldanIbartOlmaldr"),
          icon: 'error'
        })
      } else {
        this.$swal({
          //TODO LANGUAGE

          title: this.$t("generalModal.warningTitle"),
          text: this.$t("newAUCRequest.butunBolmeleri"),
          icon: 'error'
        })
      }

    },

    getPhoto(path, size) {
      return getPhoto(path, size);
    },

    selectPhoto(index) {
      this.photoIndex = index;
      window.document.getElementById('fileInput').click();
    },
    setPhoto() {
      let currentFile = this.$refs.file.files[0];

      if (window.File && window.FileReader && window.FileList && window.Blob) {

        upload(this.token, 'requestPhoto', currentFile, event => {
          this.uploadProgress = Math.round((100 * event.loaded) / event.total);
        })
            .then(response => {
              this.uploadProgress = 100;
              if (response.data.code === 200) {

                if (['RFQ', 'PQT', 'REV', 'AUC'].indexOf(this.requestType) > -1) {
                  this.editingProduct.photo = response.data.path;
                } else {

                  this.requestFiles.push({
                    id: 0,
                    path: response.data.path,
                    type: "request"
                  });

                }

              } else {
                this.$swal({
                  title: `Error ${response.data.code}`,
                  text: `${response.data.message}`,
                  icon: 'error'
                })
              }
            })
            .catch((e) => {
              this.progress = 0;
              this.$swal({
                title: `Error`,
                text: "Could not upload the file! " + e,
                icon: 'error'
              })
            });

      } else {
        //TODO LANGUAGE

        this.$swal({
          title: `Error`,
          text: "Photo upload is not supported on your browser",
          icon: 'error'
        })
      }
    },

    addNewProduct() {


      this.products.push({
        name: '',
        note: '',
        count: '',
        unit: '',
        photo: ''
      })

      this.editProduct(this.products.length - 1);
    },
    deleteProduct(index) {
      this.products.splice(index, 1)
    },
    editProduct(index) {
      this.editingProductIndex = index;
      this.editingProduct = {...this.products[index]};
      this.$bvModal.show('modal-edit-product');
    },

    saveProduct() {
      this.products[this.editingProductIndex] = this.editingProduct;
      this.$bvModal.hide('modal-edit-product');
      this.editingProductIndex = -1;
      this.editingProduct = null;
    },

    cancelSaveProduct() {
      let lastItem = this.products[this.editingProductIndex];
      if (lastItem.productType === '' || lastItem.name === '' || lastItem.count < 1 || lastItem.unit === '') {
        this.products.splice(this.editingProductIndex, 1);
      }
      this.$bvModal.hide('modal-edit-product');
      this.editingProductIndex = -1;
      this.editingProduct = null;
    },


  }

}
</script>
